import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { PostResponse } from '../studio-http-client/post-response';
import { StartSession } from '../models/start-session';
import { HttpAction } from '../studio-http-client/http-action.enum';
import { HttpHeaders } from '@angular/common/http';
import { EndSession } from '../models/end-session';

@Injectable({
  providedIn: 'root',
})
export class SessionsService {
  apiService = inject(ApiService);

  postStartSession(userId: string, startSession: StartSession): Observable<PostResponse> {
    if (!userId || userId === 'null') {
      console.error('null userId');
      throw Error('null userId');
    }
    const url = `api/Users/${userId}/Sessions/Start`;
    return this.apiService.invokeLSApi<PostResponse>(url, HttpAction.Post, startSession);
  }

  postEndSession(userId: string, endSession: EndSession): Observable<PostResponse> {
    const url = `api/Users/${userId}/Sessions/End`;
    return this.apiService.invokeLSApi<PostResponse>(url, HttpAction.Put, endSession, {
      additionalHeaders: new HttpHeaders({ UserId: userId }),
    }); // for when this is called when the next user logs in to a different shard
  }
}
